import { ActivatedRoute } from '@angular/router'
import { Component, OnInit } from '@angular/core'
import { Document } from 'app/models/document'
import { DocumentService } from 'app/services/document.service'

@Component({
  selector: 'app-file',
  templateUrl: './file.component.html',
  styleUrls: ['./file.component.scss'],
  providers: [DocumentService]
})
export class FileComponent implements OnInit {
  file: Document

  constructor(
    private documentService: DocumentService,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.getFile(params.id)
    })
  }

  getFile(id): void {
    this.documentService.getById(id).subscribe(file => {
      this.file = file
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/views/file/file.component.ts